import { Hint } from '@systemeio/ui'
import { Rule } from 'modules/automation-rules/components/rule'
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules'
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import {
  AutomationRuleErrorInterface,
  AutomationRuleViewInterface,
} from 'modules/automation-rules/types/automation-rule-interface'
import React, { Dispatch, SetStateAction } from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface SpecificTriggerRuleProps
  extends Pick<
    SpecificTriggerRulesProps,
    'getRelatedAndUnrelatedTriggersData' | 'customAddTriggerHandler' | 'noRelatedMessage'
  > {
  tempState: AutomationRuleViewInterface
  setTempState: Dispatch<SetStateAction<AutomationRuleViewInterface>>
  errors: AutomationRuleErrorInterface
  maxTriggerId: React.MutableRefObject<number>
  maxActionId: React.MutableRefObject<number>
  isPreFetching?: boolean
  isFetching: boolean
  savedTriggers?: AutomationRuleViewInterface['triggers']
  ruleId?: number
  availableTriggers?: AutomationRuleTriggersEnum[]
}

export function SpecificTriggerRule(props: SpecificTriggerRuleProps) {
  const { t } = useLocoTranslation()
  const { relatedTriggers: relatedSavedTriggers, unrelatedTriggers } =
    props.getRelatedAndUnrelatedTriggersData(props.savedTriggers ?? [])

  const { relatedTriggers: relatedTempTriggers } = props.getRelatedAndUnrelatedTriggersData(
    props.tempState.triggers,
  )

  const allowedTriggers = relatedSavedTriggers
    .map(trigger => trigger.type)
    .concat(props.availableTriggers ?? [])
    .filter(trigger => !relatedTempTriggers.find(el => el.type === trigger))

  return (
    <Rule
      {...props}
      isStaticTriggers
      hideTriggers={unrelatedTriggers.map(el => el.id)}
      allowedTriggers={allowedTriggers}
      customAddTriggerHandler={props.customAddTriggerHandler}
      customTriggerTitle={
        <Hint
          showHint={!!props.ruleId && unrelatedTriggers.length !== 0}
          label={props.noRelatedMessage(props.ruleId ?? 0)}
        >
          <span className={'text-text-primary text-[17px] font-bold'}>
            {t('dashboard.automation_rule.trigger.title')}
          </span>
        </Hint>
      }
    />
  )
}
